/* Ende Material Komponenten */
import {CdkTreeModule} from '@angular/cdk/tree';
import {CommonModule, NgOptimizedImage, registerLocaleData} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
/* Material Komponenten */
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule} from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule, MatIconRegistry} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ServiceWorkerModule} from '@angular/service-worker';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AutoCompleteModule, ComboBoxModule, MultiSelectAllModule} from '@syncfusion/ej2-angular-dropdowns';
import {AggregateService, EditService, FilterService, GridModule, PageService, SortService, ToolbarService} from '@syncfusion/ej2-angular-grids';
import {ColorPickerModule, TextBoxModule} from '@syncfusion/ej2-angular-inputs';
import {ListViewModule} from '@syncfusion/ej2-angular-lists';
/* SyncFusion Komponenten */
import {TimePickerModule} from '@syncfusion/ej2-angular-calendars';
import {TreeViewModule} from '@syncfusion/ej2-angular-navigations';
import {RichTextEditorModule} from '@syncfusion/ej2-angular-richtexteditor';
import {AgendaService, DayService, MonthService, ScheduleModule, WeekService, WorkWeekService} from '@syncfusion/ej2-angular-schedule';
import {AccumulationChartAllModule, ChartAllModule, ChartModule, RangeNavigatorAllModule} from '@syncfusion/ej2-angular-charts';
import {TreeGridModule} from '@syncfusion/ej2-angular-treegrid';
import {NgImageSliderModule} from 'ng-image-slider';
import {ToastrModule} from 'ngx-toastr';
import {WebcamModule} from 'ngx-webcam';
import {APP_LOCALE_ID} from './app-locale';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BenutzerAnmeldungComponent} from './benutzer-anmeldung/benutzer-anmeldung.component';
import {AdressEintragComponent} from './home-layout/adressen/adress-eintrag/adress-eintrag.component';
import {AdressenMobileComponent} from './home-layout/adressen/adressen-mobile/adressen-mobile.component';
import {KontaktEintragComponent} from './home-layout/adressen/kontakt-eintrag/kontakt-eintrag.component';
import {OrtAuswahlComponent} from './home-layout/adressen/ort-auswahl/ort-auswahl.component';
import {AppEinstellungenMobileComponent} from './home-layout/app-einstellungen/app-einstellungen-mobile/app-einstellungen-mobile.component';
import {AppEinstellungenComponent} from './home-layout/app-einstellungen/app-einstellungen.component';
import {CameraViewerComponent} from './home-layout/camera-viewer/camera-viewer.component';
import {AufgabeListeComponent} from './home-layout/dashboard/aufgabe-liste/aufgabe-liste.component';
import {DashboardMobileComponent} from './home-layout/dashboard/dashboard-mobile/dashboard-mobile.component';
import {DashboardComponent} from './home-layout/dashboard/dashboard.component';
import {NotizListeComponent} from './home-layout/dashboard/notiz-liste/notiz-liste.component';
import {TerminListeComponent} from './home-layout/dashboard/termin-liste/termin-liste.component';
import {HomeLayoutComponent} from './home-layout/home-layout.component';
import {ImageEditorComponent} from './home-layout/image-editor/image-editor.component';
import {PersonalTasksComponent} from './home-layout/meine-aufgaben/personal-task.component';
import {MeineNotizenComponent} from './home-layout/meine-notizen/meine-notizen.component';
import {MeineTermineComponent} from './home-layout/meine-termine/meine-termine.component';
import {ObjektAdresseComponent} from './home-layout/objekte/objekt-adresse/objekt-adresse.component';
import {ObjekteMobileComponent} from './home-layout/objekte/objekte-mobile/objekte-mobile.component';
import {ObjekteComponent} from './home-layout/objekte/objekte.component';
import {AufgabeEintragComponent} from './home-layout/pendenzen/aufgabe-eintrag/aufgabe-eintrag.component';
import {CalendarComponent} from './home-layout/pendenzen/calendar/calendar.component';
import {NotizEintragComponent} from './home-layout/pendenzen/notiz-eintrag/notiz-eintrag.component';
import {PendenzenComponent} from './home-layout/pendenzen/pendenzen.component';
import {TerminEintragComponent} from './home-layout/pendenzen/termin-eintrag/termin-eintrag.component';
import {AgendaComponent} from './home-layout/service-app/agenda/agenda.component';
import {EinsatzEintragComponent} from './home-layout/service-app/agenda/einsatz-eintrag/einsatz-eintrag.component';
import {TimeRecorderComponent} from './home-layout/service-app/agenda/time-recorder/time-recorder.component';
import {AuftraegeComponent} from './home-layout/service-app/auftraege/auftraege.component';
import {DocsComponent} from './home-layout/service-app/docs/docs.component';
import {PicsComponent} from './home-layout/service-app/pics/pics.component';
import {ArtikelstammComponent} from './home-layout/service-app/rapport-positionen/artikelstamm/artikelstamm.component';
import {PosMutationComponent} from './home-layout/service-app/rapport-positionen/pos-mutation/pos-mutation.component';
import {RapportPositionenComponent} from './home-layout/service-app/rapport-positionen/rapport-positionen.component';
import {MailFormComponent} from './home-layout/service-app/rapport/mail-form/mail-form.component';
import {RapportComponent} from './home-layout/service-app/rapport/rapport.component';
import {ServiceAppComponent} from './home-layout/service-app/service-app.component';
import {ServiceSynchronisationComponent} from './home-layout/service-app/service-synchronisation/service-synchronisation.component';
import {TerminDetailsComponent} from './home-layout/service-app/termin-details/termin-details.component';
import {ZeitMutationComponent} from './home-layout/service-app/zeiten/zeit-mutation/zeit-mutation.component';
import {ZeitenComponent} from './home-layout/service-app/zeiten/zeiten.component';
import {TerminMobileComponent} from './home-layout/termin/termin-mobile/termin-mobile.component';
import {TerminComponent} from './home-layout/termin/termin.component';
import {DatumFormatPipe} from './pipes/datum-format.pipe';
import {AdresseDataService} from './services/adresse-data.service';
import {HelperService} from './services/helper.service';
import {SwissFormsModule} from './swiss-forms/swiss-forms.module';
import {AuftragDialogComponent} from './time-app/dialogs/auftrag-dialog/auftrag-dialog.component';
import {EditImageDetailsComponent} from './time-app/dialogs/edit-image-details/edit-image-details.component';
import {KostenstelleDialogComponent} from './time-app/dialogs/kostenstelle-dialog/kostenstelle-dialog.component';
import {SpesenDialogComponent} from './time-app/dialogs/spesen-dialog/spesen-dialog.component';
import {EditImgComponent} from './time-app/edit-img/edit-img.component';
import {GalleryComponent} from './time-app/gallery/gallery.component';
import {HeaderComponent} from './time-app/header/header.component';
import {TimePipePipe} from './time-app/pipes/time-pipe.pipe';
import {SavedWorktimesComponent} from './time-app/saved-worktimes/saved-worktimes.component';
import {ScanComponent} from './time-app/scan/scan.component';
import {SettingsComponent} from './time-app/settings/settings.component';
import {ShareOrderComponent} from './time-app/share-order/share-order.component';
import {CheckBoxModule, SpeedDialModule} from '@syncfusion/ej2-angular-buttons';

/* Zeiterfassungs-App */
import {TerminEintragMobileComponent} from './home-layout/pendenzen/termin-eintrag-mobile/termin-eintrag-mobile.component';
import {TimeAppComponent} from './time-app/time-app.component';
import {AddressNotizComponent} from './home-layout/adressen/address-notiz/address-notiz.component';
import {VinavonUpdateService} from './services/vinavon-update.service';
import {AnnotationStorageServiceService} from './services/annotation-storage-service.service';
import {ObjektRapportComponent} from './home-layout/objekte/objekt-rapport/objekt-rapport.component';
import {ObjektSchutzComponent} from './home-layout/objekte/objekt-schutz/objekt-schutz.component';
import {ZahlenFormatPipe} from './pipes/zahlen-format.pipe';
import {DBControlComponent} from './home-layout/app-einstellungen/dbcontrol/dbcontrol.component';
import {PDFViewerComponent} from './pdfviewer/pdfviewer.component';
import {ShowOpenDaysDialogComponent} from './time-app/dialogs/show-open-days-dialog/show-open-days-dialog.component';
import {InputLayoutModule} from './reusable-components/input-layout/input-layout.module';
import {DialogLayoutComponent} from './reusable-components/dialog-layout/dialog-layout.component';
import {NavigationItemsComponent} from './reusable-components/navigation-items/navigation-items.component';
import {UserProfileComponent} from './user-profile/user-profile.component';
import {SnackbarContentLayoutComponent} from './reusable-components/snackbar-content-layout/snackbar-content-layout.component';
import {SnackbarHeaderLayoutComponent} from './reusable-components/snackbar-header-layout/snackbar-header-layout.component';
import {HeaderLayoutComponent} from './reusable-components/header-layout/header-layout.component';
import {VinavonButtonComponent} from './reusable-components/vinavon-button/vinavon-button.component';
import {ShareEmpOrderComponent} from './time-app/share-emp-order/share-emp-order.component';
import {BackupService} from './services/backup.service';
import {EmployeeNoteComponent} from './time-app/share-order/employeeNote/employeeNote.component';
import {DailyNotesComponent} from './time-app/share-order/dailyNotes/dailyNotes.component';
import {MailPreviewDialogComponent} from './swiss-forms/mail-preview-dialog/mail-preview-dialog.component';
import {MeineTermineDetailViewComponent} from './home-layout/meine-termine-detail-view/meine-termine-detail-view.component';
import {MeineAufgabenDetailViewComponent} from './home-layout/meine-aufgaben-detail-view/meine-aufgaben-detail-view.component';
/* Ende Zeiterfassungs-App */
import {BlockScrollStrategy, Overlay} from '@angular/cdk/overlay';
import {DeviceDetectionService} from './services/device-detection-service';
import {TreeviewService} from './services/treeview.service';
import {PDFViewerDialogComponent} from './pdfviewer/pdfviewerDialog.component';
import {FileNameDialogComponent} from './swiss-forms/filename-dialog/filename-dialog.component';
import {AppointmentDetailsComponent} from './time-app/share-order/appointmentDetails/appointment-details.component';
import {TimeoutInterceptor} from './interceptors/http-timeout.interceptor';
import {ObjectListViewComponent} from './home-layout/objekte/object-listview/object-listview.component';
import {ObjectSearchComponent} from './home-layout/objekte/object-search/object-search.component';

import {ForIPipe} from './pipes/for-i.pipe';
import {TreeviewComponent} from './home-layout/objekte/treeview/treeview.component';
import {TreeviewNodeComponent} from './home-layout/objekte/treeview/treeview-node/treeview-node.component';
import {TreeviewPageComponent} from './home-layout/objekte/treeview/tree-page/treeview-page.component';
import {TimeAppDocumentsComponent} from './time-app/time-app-documents-component/time-app-documents.component';
import {TimeAppDocumentsService} from './time-app/services/time-app-documents.service';
import {TimeAppWorkSupplyManagementComponent} from './time-app/time-app-material/time-app-work-supply-management.component';
import {TimeAppWorkSupplyListComponent} from './time-app/time-app-material/time-app-work-supply-list/time-app-work-supply-list.component';
import {TimeAppWorkSupplyEntryComponent} from './time-app/time-app-material/time-app-work-supply-entry/time-app-work-supply-entry.component';
import {TimeAppWorkSupplyProductsDialogComponent} from './time-app/time-app-material/time-app-work-supply-products/time-app-work-supply-products-dialog.component';
import {TimeAppWorkSupplyProductListComponent} from './time-app/time-app-material/time-app-work-supply-product-list/time-app-work-supply-product-list.component';
import {AddressOverviewComponent} from './home-layout/adressen/address-overview/address-overview.component';
import {AddressDetailComponent} from './home-layout/adressen/address-detail/address-detail.component';
import {AddressSearchComponent} from './home-layout/adressen/address-search/address-search.component';
import {CollapsibleBoxComponent} from './reusable-components/collapsible-box/collapsible-box.component';
import {WebServiceAvailableInterceptor} from './interceptors/web-service-available.interceptor';
import {UpdateLogService} from './services/update-log-service';
import {AuthInterceptor} from './interceptors/auth.interceptor';
import {environment} from 'src/environments/environment';
import {TenantHeaderInterceptor} from './interceptors/tenant-id-header.interceptor';
import {ServiceWorkerClientCommunicationService} from './services/service-worker-client-communication-service';
import {DocumentManagementService} from './services/document-management.service';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { ServiceAppDocumentTaskFactory} from './services/service-app-document-synchronisation-service';
import { BaseUrlInterceptor } from './interceptors/base-url.interceptor';

registerLocaleData(localeDe);

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
    return () => overlay.scrollStrategies.block();
}

export function appInit(helperService: HelperService): () => Promise<void> {
    return () => new Promise<void>(async (resolve) => {
        await helperService.loadSwissWebServiceConfig();
        return resolve();
    });
}

@NgModule({
    declarations: [
        TreeviewComponent,
        TreeviewPageComponent,
        TreeviewNodeComponent,
        AppComponent,
        HomeLayoutComponent,
        DashboardComponent,
        PDFViewerComponent,
        PDFViewerDialogComponent,
        ObjectSearchComponent,
        ObjectListViewComponent,
        ObjekteComponent,
        PendenzenComponent,
        TerminComponent,
        BenutzerAnmeldungComponent,
        DatumFormatPipe,
        AppEinstellungenComponent,
        ZeitenComponent,
        RapportPositionenComponent,
        RapportComponent,
        ZeitMutationComponent,
        ServiceAppComponent,
        AgendaComponent,
        DocsComponent,
        PosMutationComponent,
        ArtikelstammComponent,
        PicsComponent,
        AuftraegeComponent,
        MailFormComponent,
        TerminDetailsComponent,
        CalendarComponent,
        AufgabeEintragComponent,
        NotizEintragComponent,
        TerminEintragComponent,
        AdressEintragComponent,
        TerminListeComponent,
        MeineTermineComponent,
        KontaktEintragComponent,
        ObjektAdresseComponent,
        NotizListeComponent,
        AufgabeListeComponent,
        PersonalTasksComponent,
        MeineNotizenComponent,
        ImageEditorComponent,
        OrtAuswahlComponent,
        CameraViewerComponent,
        EinsatzEintragComponent,
        ServiceSynchronisationComponent,
        MeineTermineDetailViewComponent,
        MeineAufgabenDetailViewComponent,
        TimeAppComponent,
        ShareOrderComponent,
        ScanComponent,
        SettingsComponent,
        HeaderComponent,
        AuftragDialogComponent,
        KostenstelleDialogComponent,
        SpesenDialogComponent,
        SavedWorktimesComponent,
        GalleryComponent,
        EditImgComponent,
        TimePipePipe,
        EditImageDetailsComponent,
        TimeRecorderComponent,
        ObjekteMobileComponent,
        AdressenMobileComponent,
        TerminMobileComponent,
        DashboardMobileComponent,
        AppEinstellungenMobileComponent,
        EmployeeNoteComponent,
        DailyNotesComponent,
        TerminEintragMobileComponent,
        ShowOpenDaysDialogComponent,
        AddressNotizComponent,
        ObjektRapportComponent,
        ObjektSchutzComponent,
        ZahlenFormatPipe,
        ForIPipe,
        DBControlComponent,
        AppointmentDetailsComponent,
        DialogLayoutComponent,
        NavigationItemsComponent,
        UserProfileComponent,
        SnackbarContentLayoutComponent,
        SnackbarHeaderLayoutComponent,
        HeaderLayoutComponent,
        VinavonButtonComponent,
        ShareEmpOrderComponent,
        MailPreviewDialogComponent,
        FileNameDialogComponent,
        TimeAppDocumentsComponent,
        TimeAppWorkSupplyManagementComponent,
        TimeAppWorkSupplyListComponent,
        TimeAppWorkSupplyEntryComponent,
        TimeAppWorkSupplyProductsDialogComponent,
        TimeAppWorkSupplyProductListComponent,
        AddressOverviewComponent,
        AddressDetailComponent,
        AddressSearchComponent,
        CollapsibleBoxComponent,
    ],
    imports: [
        InputLayoutModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        CommonModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        SwissFormsModule,
        CdkTreeModule,
        FontAwesomeModule,
        MatDialogModule,
        MatExpansionModule,
        MatSidenavModule,
        MatDividerModule,
        MatListModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        MatMomentDateModule,
        MatTableModule,
        MatBadgeModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatMenuModule,
        MatAutocompleteModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatTreeModule,
        MatGridListModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSliderModule,
        MatTooltipModule,
        TreeViewModule, // SyncFusion
        TimePickerModule, // SyncFusion
        ListViewModule, // SyncFusion
        RichTextEditorModule, // SyncFusion
        ScheduleModule, // SyncFusion
        GridModule, // SyncFusion
        CheckBoxModule, // SyncFusion
        MultiSelectAllModule, // SyncFusion
        ComboBoxModule, // Syncfusion
        ColorPickerModule, // SyncFusion
        TextBoxModule, // SyncFusion
        ChartModule, // SyncFusion
        ChartAllModule, // SyncFusion
        AccumulationChartAllModule, // SyncFusion
        RangeNavigatorAllModule, // SyncFusion
        TreeGridModule, // SyncFusion
        AutoCompleteModule, // SyncFusion
        SpeedDialModule, // SyncFusion
        ColorPickerModule,
        MatSelectModule,
        MatTabsModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        NgImageSliderModule,
        ToastrModule.forRoot(),
        WebcamModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        HammerModule,
        ServiceWorkerModule.register('/service-worker.js', {enabled: environment.enableServiceWorker, registrationStrategy: 'registerImmediately'}),
        NgOptimizedImage,
        ScrollingModule,
        TranslateModule,
    ],
    exports: [MatFormFieldModule],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        AdresseDataService,
        BackupService,
        VinavonUpdateService,
        HelperService,
        UpdateLogService,
        MatDatepickerModule,
        DatumFormatPipe,
        ZahlenFormatPipe,
        ForIPipe,
        AnnotationStorageServiceService,
        AgendaService,
        DayService,
        WeekService,
        WorkWeekService,
        MonthService,
        AggregateService,
        SortService,
        FilterService,
        EditService,
        ToolbarService,
        PageService,
        DeviceDetectionService,
        TreeviewService,
        TimeAppDocumentsService,
        ServiceWorkerClientCommunicationService,
        ServiceAppDocumentTaskFactory,
        DocumentManagementService,
        [
            {
                provide: HTTP_INTERCEPTORS,
                useClass: TimeoutInterceptor,
                multi: true,
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: WebServiceAvailableInterceptor,
                multi: true,
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: AuthInterceptor,
                multi: true,
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: TenantHeaderInterceptor,
                multi: true,
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: BaseUrlInterceptor,
                multi: true,
            },
        ],
        {
            provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
            useFactory: scrollFactory,
            deps: [Overlay],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appInit,
            multi: true,
            deps: [HelperService, UpdateLogService, DocumentManagementService],
        },
        {
            provide: LOCALE_ID,
            useValue: APP_LOCALE_ID,
        },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: HammerGestureConfig,
            deps: [],
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {subscriptSizing: 'dynamic'},
        },
        // TODO 2025-11-13 https://swissjira.atlassian.net/browse/EN-4125 provide translation for paginators in general https://stackblitz.com/edit/angular-ivy-7g19ec?file=src%2Fapp%2Fdutch-paginator-intl.ts
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(private matIconRegistry: MatIconRegistry) {
        this.matIconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    }
}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}
